import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_sales_commission_pricing_model_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    range_from: fromDatatype.NumericDatatypeInterface;
    range_to: fromDatatype.NumericDatatypeInterface;
    commission_multiplier: fromDatatype.NumericDatatypeInterface;
    commission_value: fromDatatype.NumericDatatypeInterface;
    membership_point_multiplier: fromDatatype.NumericDatatypeInterface;
    membership_point_value: fromDatatype.NumericDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_sales_commission_pricing_model_line_RowClass implements bl_fi_sales_commission_pricing_model_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    range_from: fromDatatype.NumericDatatypeInterface;
    range_to: fromDatatype.NumericDatatypeInterface;
    commission_multiplier: fromDatatype.NumericDatatypeInterface;
    commission_value: fromDatatype.NumericDatatypeInterface;
    membership_point_multiplier: fromDatatype.NumericDatatypeInterface;
    membership_point_value: fromDatatype.NumericDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
